import { BankInstrumentComponents } from '../../types';
import { RUBOfflineForm } from './components/Form';
import { RUBOfflineTab } from './components/Tab';

export const RUBOffline: BankInstrumentComponents = { Content: RUBOfflineForm, Tab: RUBOfflineTab };
